export default __webpack_public_path__ + "static/media/mongodb.1aca075d.svg";